var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMBubble = function SvgMBubble(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#EEC764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30859 7.46875H9.79688L11.9883 13.7324L14.1797 7.46875H15.668L12.5859 16H11.3906L8.30859 7.46875ZM7.50586 7.46875H8.98828L9.25781 13.5742V16H7.50586V7.46875ZM14.9883 7.46875H16.4766V16H14.7188V13.5742L14.9883 7.46875Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMBubble);
export { ForwardRef as ReactComponent };